import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCreateNeedMutation } from "../../../autogen/bff-api";
import { urls } from "../../../urls";

/**
 * Creates a draft need and navigates to its edit form. Mirrors the "New
 * procurement" create-then-navigate handler on a stable component — never a
 * create-on-mount route effect.
 */
export const useCreateNeed = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  const [createNeed, { isLoading }] = useCreateNeedMutation();
  const [isNavigating, setIsNavigating] = useState(false);

  const create = async () => {
    setIsNavigating(true);
    try {
      const need = await createNeed({ createNeedRequest: {} }).unwrap();
      navigate(urls.v2.needs.edit.go(need.id));
    } catch {
      setIsNavigating(false);
      toast({ title: t("Could not create need"), status: "error", duration: 3000 });
    }
  };

  return { create, isCreating: isLoading || isNavigating };
};
